module.exports = __webpack_public_path__ + "images/sochi/header.png";